import { Component } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-create-estudiantes',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './create-estudiantes.component.html',
  styleUrl: './create-estudiantes.component.css',
})
export class CreateEstudiantesComponent {
  file: File | null = null;
  result: any = null;
  errorMessage: string | null = null;

  constructor(private http: HttpClient, private router: Router) {}

  onFileChange(event: any) {
    if (event.target.files.length > 0) {
      this.file = event.target.files[0];
      //console.log(this.file); // Agrega esto para verificar el archivo
    }
  }

  onSubmit(event: Event) {
    event.preventDefault(); // Prevenir recarga de la página
    //console.log('Submit ejecutado');

    if (!this.file) {
      this.errorMessage = 'Por favor, selecciona un archivo.';
      return;
    }

    Swal.fire({
      title: 'Procesando...',
      text: 'Por favor, espere.',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    const formData = new FormData();
    formData.append('file', this.file);

    this.http.post(environment.apiUrl + '/usuario/upload', formData).subscribe({
      next: (response: any) => {
        this.result = response;
        this.errorMessage = null;
        Swal.close();
        Swal.fire({
          icon: 'success',
          title: 'Éxito',
          text: 'Los registros se cargaron correctamente.',
        });
        //console.log('Archivo subido con éxito:', response);
      },
      error: (error) => {
        this.errorMessage = 'Error al subir el archivo. Inténtalo de nuevo.';
        Swal.close();
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.error.message || 'Error al subir el archivo',
        });
        //console.error('Error:', error);
      },
    });
  }

  goBack() {
    this.router.navigate(['/estudiantes']);
  }
}
